import { render, staticRenderFns } from "./vendor-premium.vue?vue&type=template&id=cc7191a4&"
import script from "./vendor-premium.vue?vue&type=script&lang=js&"
export * from "./vendor-premium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports